import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const InterviewStatusWrapper = styled.div`
  background: #673490;
  color: #fff;
  border-radius: 8px;
  padding: 20px;
  height: fit-content;
  box-shadow: 0 0 15px #dcdcdc;
  font-family: Raleway;

  ${mediaMaxWidth.tablet`
    margin-bottom: -5px;
  `}
`;

export const Status = styled.div`
  font-size: 1.3em;
  font-weight: 600;
  margin-bottom: 5px;
`;

export const LastChange = styled.div`
  font-size: 1.1em;
`;
